import { useEffect } from "react";
import { apiFetch } from "../../../api/core";
import { useEditItem2 } from "../../../api/useNewItem";
import { useCRMContext } from "../CRMContext"
import { CRMSettings } from "../types";

export const useCRMSettingsEdit = () => {
  const ctx = useCRMContext();

  const data = useEditItem2<CRMSettings>({
    setToSaved: true,
    dontResetOnSave: true,
    save: async (item, changes) => {
      const result = await apiFetch<CRMSettings>(`${ctx.apiPath}/settings`, "put", changes);
      ctx.reloadSettings();
      return result;
    }
  });

  useEffect(() => {
    if((ctx.settings as any)._id && !data.isEditing) {
      data.startEditing(ctx.settings);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.settings, data.isEditing]);

  return {
    ...data,
  }
}
